import { render, staticRenderFns } from "./NVOCCLineQuotation.vue?vue&type=template&id=61888ff2&scoped=true&"
import script from "./NVOCCLineQuotation.vue?vue&type=script&lang=js&"
export * from "./NVOCCLineQuotation.vue?vue&type=script&lang=js&"
import style0 from "./NVOCCLineQuotation.vue?vue&type=style&index=0&id=61888ff2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61888ff2",
  null
  
)

export default component.exports